import Base from 'app/views/base';

import tmpl from 'templates/empty';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize() {
    $('body').scrollspy({ target: '.scrollnav' });
  },
});



// WEBPACK FOOTER //
// ./app/views/scrollspy_page.js